import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { deleteAirport } from "../../api/apiAirports";
import parseError from "../../utils/parseError";

const useDeleteAirport = () => {
    const queryClient = useQueryClient();

    const { mutate: deleteAirportAction, isPending } = useMutation({
        mutationFn: deleteAirport,
        onSuccess: (res) => {
            const message = res?.message || "Airport deleted successfully";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["airports"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to delete airport");
        },
    });

    return { deleteAirport: deleteAirportAction, isDelete: isPending };
};

export default useDeleteAirport;
